<script setup>
import HorizontalBusinessesMenu from '@/components/Menus/Businesses/HorizontalBusinessesMenu.vue'

definePage({ meta: { ...PageMeta.Businesses.preview.meta, pageTitle: 'Business' } })

import BusinessPreviewPage from '@/views/setup/businesses/preview/BusinessPreviewPage.vue'

const route = useRoute()

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalBusinessesMenu :business-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <BusinessPreviewPage
          v-if="route.params.guid"
          :business-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
